import { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";

const Card = (props) => {
  return (
    <>
      {props.type === "loader" && (
        <div className="movie-card m-2" onClick={() => window.scrollTo(0, 0)}>
          <Skeleton
            sx={{ bgcolor: "grey.900" }}
            variant="rectangular"
            width={200}
            height={300}
          />
        </div>
      )}
      {props.type === "loader_results" && (
        <>
          <div
            className={`movie-card m-2 `}
            onClick={() => window.scrollTo(0, 0)}
          >
            <div className="skeleton__Search">
              <Skeleton
                sx={{ bgcolor: "grey.900" }}
                variant="rectangular"
                width={280}
                height={390}
                className="skeleton__Search mb-1"
              />
            </div>

            <Link
              to={`/pelicula/${props.movie.id}`}
              style={{ zIndex: "300", position: "relative" }}
            >
              <img
                src={`https://image.tmdb.org/t/p/w500/${props.movie.poster_path}`}
                alt={`Poster de ${props.movie.title}`}
              />
            </Link>
          </div>
        </>
      )}

      {props.type !== "loader_results" && props.type !== "loader" && (
        <div
          className={`movie-card m-2 `}
          onClick={() => window.scrollTo(0, 0)}
        >
          <Link to={`/pelicula/${props.movie.id}`}>
            <img
              // src={`https:image.tmdb.org/t/p/w500/${props.movie.poster_path}`}
              src={`https://image.tmdb.org/t/p/w500/${props.movie.poster_path}`}
              alt={`Poster de ${props.movie.title}`}
            />
          </Link>
        </div>
      )}
    </>
  );
};

export default Card;
